import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatalogoProdutosComponent } from './catalogo-produtos.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'importar' },
  { path: ':mode', component: CatalogoProdutosComponent },
  { path: '**', redirectTo: 'importar' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatalogoProdutosRoutingModule {}
